import React, { useEffect, useState } from 'react';
import { Doughnut } from 'react-chartjs-2';
import { Chart, registerables, ArcElement } from 'chart.js';
import useMediaQuery from '@mui/material/useMediaQuery';
Chart.register(...registerables, ArcElement);

const PieChart = ({ principalAmount, totalInterestPaidAmortization, mortgageInsurance }) => {
  const isMobile = useMediaQuery('(max-width:599px)');
  const [chartData, setChartData] = useState({});

  useEffect(() => {
    const principal = parseFloat(principalAmount);
    const totalInterest = parseFloat(totalInterestPaidAmortization);
    const insurance = parseFloat(mortgageInsurance);

    const formatCurrency = (value) =>
      value.toLocaleString('en-CA', { style: 'currency', currency: 'CAD', minimumFractionDigits: 0 });

    const total = principal + totalInterest + insurance;

    const data = {
      labels: ['Capital', 'Intereses', 'Seguro CMHC'],
      datasets: [
        {
          data: [principal, totalInterest, insurance],
          backgroundColor: ['#1E3A5F', '#D32F2F', '#5F6B7A'],
          hoverBackgroundColor: ['#1A3152', '#B71C1C', '#7D8690'],
          borderColor: '#FFFFFF',
          borderWidth: 3,
          hoverOffset: 6,
        },
      ],
    };

    const options = {
      responsive: true,
      maintainAspectRatio: false,
      cutout: '68%',
      layout: { padding: { bottom: 8 } },
      plugins: {
        legend: {
          position: isMobile ? 'bottom' : 'right',
          labels: {
            font: { size: isMobile ? 11 : 12, family: 'Inter, sans-serif' },
            color: '#1A1A1A',
            usePointStyle: true,
            pointStyleWidth: 10,
            padding: 16,
            generateLabels: function (chart) {
              const dataset = chart.data.datasets[0];
              return chart.data.labels.map((label, index) => {
                const value = dataset.data[index];
                const pct = ((value / total) * 100).toFixed(1);
                return {
                  text: `${label}  ${formatCurrency(value)}  (${pct}%)`,
                  fillStyle: dataset.backgroundColor[index],
                  strokeStyle: 'transparent',
                  pointStyle: 'rectRounded',
                };
              });
            },
          },
        },
        tooltip: {
          bodyFont: { family: 'Inter, sans-serif' },
          titleFont: { family: 'Inter, sans-serif', weight: 600 },
          bodyColor: '#1A1A1A',
          titleColor: '#1A1A1A',
          backgroundColor: '#FFFFFF',
          borderColor: '#E6E9EE',
          borderWidth: 1,
          cornerRadius: 8,
          padding: 12,
          callbacks: {
            label: (context) => {
              const value = context.parsed || 0;
              const pct = ((value / total) * 100).toFixed(1) + '%';
              return ` ${context.label}: ${formatCurrency(value)} (${pct})`;
            },
          },
        },
      },
    };

    setChartData({ data, options });
  }, [principalAmount, totalInterestPaidAmortization, mortgageInsurance]);

  if (!chartData.data) return null;

  return <Doughnut data={chartData.data} options={chartData.options} />;
};

export default PieChart;
